/**
 *
 * Asynchronously loads the component for OrderCreate
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { PageLoading } from 'components/Loading'

export default loadable({
  loader: () => import('./OrderCreate' /* webpackChunkName: "OrderCreate" */),
  loading: <PageLoading />
})
